import { createContext, useContext } from 'react';
const HamsterContext = createContext({});
const HamsterProvider = HamsterContext.Provider;
// Hook to access the appStore anywhere
function useAppStore() {
    if (!HamsterContext) {
        throw new Error('AppStoreContext is not initialized. Call init() before invoking useAppStore() ');
    }
    const storeConfig = useContext(HamsterContext);
    if (!storeConfig) {
        throw new Error('useAppStore() can only be used inside the AppStoreContext provider');
    }
    return storeConfig.store;
}
function useAppStoreConfig() {
    if (!HamsterContext) {
        throw new Error('AppStoreContext is not initialized. Call init() before invoking useAppStore() ');
    }
    const storeConfig = useContext(HamsterContext);
    if (!storeConfig) {
        throw new Error('useAppStore() can only be used inside the AppStoreContext provider');
    }
    return storeConfig;
}
/**
 * Expose the useQuery of AppStoreConfig so that it can be used just like the original one.
 * @param query
 * @param options
 */
function useQuery(query, options) {
    if (!HamsterContext) {
        throw new Error('AppStoreContext is not initialized. Call init() before invoking useAppStore() ');
    }
    const storeConfig = useContext(HamsterContext);
    if (!storeConfig) {
        throw new Error('useAppStore() can only be used inside the AppStoreContext provider');
    }
    // TODO: figure out proper typing. as QueryLike<any, DATA> shoudl not be required here
    return storeConfig.useQuery(query, options);
}
export { useAppStore, useQuery, useAppStoreConfig, HamsterContext, HamsterProvider };
